<template>
    <v-container>
        <v-row>
            <h2>Edit</h2>
        </v-row>
        <v-row>
            <v-col cols="12">
                <editor
                    ref="toastEditor"
                    :initialValue="content"
                    height="400px"
                    initialEditType="wysiwyg"        
                    useCommandShortcut="true"
                    @change="onEditorChange"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import '@toast-ui/editor/dist/toastui-editor.css';
import { Editor } from '@toast-ui/vue-editor';

export default {
  components: { Editor },
  data() {
    return {
      content: 'dfvxcvc',
    };
  },
  methods:{
    onEditorChange() {
      const markdown = this.$refs.toastEditor.invoke('getMarkdown');
      this.content = markdown;
    },
  },
};
</script>
